__turbopack_context__.v({
  "fade-in": "AnimatedIconUtensils-module-scss-module__yvt0XG__fade-in",
  "root": "AnimatedIconUtensils-module-scss-module__yvt0XG__root",
});
